import {
  Paper,
  Group,
  Text,
  Button,
  ThemeIcon,
  Box,
  Indicator,
} from "@mantine/core";
import { IconCalendar, IconInfinity } from "@tabler/icons-react";
import { Logo } from "../../../../../layouts/Logo";

export function DemoBanner() {
  return (
    <Paper radius="lg" p="md" mb="lg" withBorder style={{borderColor: "var(--mantine-color-primary-6)", borderWidth: 1}}>
      <Group justify="space-between" wrap="wrap" gap="md">
        <Group gap="xl" wrap="nowrap" style={{ flex: 1, minWidth: 240 }}>
          <Indicator
            inline
            label={<IconCalendar size={14} />}
            size={28}
            color="primary"
            withBorder
            offset={4}
            position="bottom-end"
          >
            <ThemeIcon variant="outline" size={48} px={4} radius={"md"}>
              <Logo isLoader w={64} />
            </ThemeIcon>
          </Indicator>
          <Box>
            <Text fw={700} fz={"lg"} lh={1.3}>
              Réservez une démo pour prendre en main Magileads
            </Text>
            <Text fz="sm" c="gray.7">
              Découvrez toutes les fonctionnalités de Magileads lors d'une
              démonstration personnalisée avec l'un de nos experts.
            </Text>
          </Box>
        </Group>
        <Button variant="light" radius="xl" size="compact-md" c={"black"} fw={600} mr={"4%"}>
          Je réserve ma démo
        </Button>
      </Group>
    </Paper>
  );
}

export default DemoBanner;
